/** @format */

import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { connect } from 'react-redux';
import {
  addCustomer,
  removeCustomer,
} from '../../redux/customers/customer.actions';

import { selectMessageType } from '../../redux/message/message.selector';
import { createStructuredSelector } from 'reselect';
import './customerByFlight-viz.styles.css';
import { selectFlightTimes } from '../../redux/flightData/flightData.selector';
import * as dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);

const CustomerByFlightRecord = (props) => {
  const { firstName, lastName, phoneNumber, emailAddress, id, pnr } =
    props.customer;
  const { addCstr, removeCstr, messageType, flightTimes } = props;

  const [isSelected, setIsSelected] = useState(true);

  useEffect(
    () =>
      isSelected &&
      ((messageType === 'Text' && phoneNumber) ||
        (messageType === 'Email' && emailAddress))
        ? addCstr({
            flightid: props.flightid,
            name: `${firstName} ${lastName}`,
            phoneNumber: phoneNumber,
            emailAddress: emailAddress,
            id: id,
            pnr,
          })
        : undefined,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      messageType,
      phoneNumber,
      props.flightid,
      firstName,
      lastName,
      emailAddress,
      addCstr,
      id,
      isSelected,
    ]
  );

  const handleClick = () => {
    if (isSelected) {
      removeCstr({
        flightid: props.flightid,
        name: `${firstName} ${lastName}`,
        phoneNumber: phoneNumber,
        emailAddress: emailAddress,
        id: id,
        pnr,
      });
    } else {
      addCstr({
        flightid: props.flightid,
        name: `${firstName} ${lastName}`,
        phoneNumber: phoneNumber,
        emailAddress: emailAddress,
        id: id,
        pnr,
      });
    }
    setIsSelected((current) => !current);
  };

  return (
    <motion.div
      whileTap={{ scale: 0.9 }}
      className="record"
      style={{
        backgroundColor:
          isSelected &&
          ((messageType === 'Text' && phoneNumber) ||
            (messageType === 'Email' && emailAddress))
            ? '#d3ffd3'
            : 'white',
      }}
      onClick={
        (messageType === 'Text' && phoneNumber) ||
        (messageType === 'Email' && emailAddress)
          ? () => handleClick()
          : null
      }
    >
      <div className="flightId">{`${props.flightid}`}</div>

      <div className="flightTime">{`${
        flightTimes[props.flightid] !== undefined
          ? dayjs.utc(flightTimes[props.flightid].schedDep).format('hh:mm a')
          : 'NA'
      }`}</div>

      <div className="flightTime">{`${
        flightTimes[props.flightid] !== undefined
          ? dayjs.utc(flightTimes[props.flightid].estDep).format('hh:mm a')
          : 'NA'
      }`}</div>

      <div className="flightTime">{`${
        flightTimes[props.flightid] !== undefined
          ? dayjs.utc(flightTimes[props.flightid].schedArr).format('hh:mm a')
          : 'NA'
      }`}</div>

      <div className="flightTime">{`${
        flightTimes[props.flightid] !== undefined
          ? dayjs.utc(flightTimes[props.flightid].estArr).format('hh:mm a')
          : 'NA'
      }`}</div>

      <div className="name">{`${firstName} ${lastName}`}</div>
      <div
        className="phone-number"
        style={{ color: phoneNumber ? '#0bdb43' : 'red' }}
      >{`${phoneNumber}`}</div>
      <div
        className="email-address"
        style={{ color: emailAddress ? '#0bdb43' : 'red' }}
      >{`${emailAddress}`}</div>
    </motion.div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  addCstr: (customer) => dispatch(addCustomer(customer)),
  removeCstr: (customer) => dispatch(removeCustomer(customer)),
});

const mapStateToProps = createStructuredSelector({
  messageType: selectMessageType,
  flightTimes: selectFlightTimes,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CustomerByFlightRecord);
